<template>
    
    
    <div class="col-sm-6 d-flex mt-5">
        
        <div class="check is-checked" v-if="!checkDone">
            <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.99989 11.3566L1.7999 7.11599L0.399902 8.52951L5.99989 14.1836L17.9999 2.0677L16.5999 0.654175L5.99989 11.3566Z"
                fill="white"
                />
            </svg>
        </div>
        <div class="check" v-else></div>
        <div class="check-stage">
            <h6>{{stage.name}}</h6>
            <p>{{beginningStage}} - {{moment(finalStage).format('D MMM, YYYY')}}</p>
        </div>
    </div>
    
    
    
</template>

<script>
import moment from 'moment';
export default {
    props: ['stage', 'crop', 'allStages'],
    data() {
        return {
            moment
        }
    },
    computed: {
        filterStages() {
            if(this.allStages) {
                const stIndex = this.allStages.findIndex(item => item.name === this.stage.name);
                return this.allStages.slice(0, stIndex+1);
            }
            return '';
        },
        finalStage() {
            const weeks = this.filterStages ? this.filterStages.map(item => item.no_of_weeks) : [];
            const total = weeks.reduce((sum, current) => sum + current, 0);
            if(total !== 0) {
              return this.moment(this.crop.date_planted).add(total, 'weeks');  
            }
            return '';
        },
        beginningStage() {
            return this.finalStage ? this.moment(this.finalStage).subtract(this.stage.no_of_weeks, 'week').format('D MMM, YYYY') : '';
        },
        weeks() {
            return this.filterStages ? this.filterStages.map(item => item.no_of_weeks) : [];
        },
        checkDone() {
            const currentTime = this.moment().unix();
            const total = this.weeks.reduce((sum, current) => sum + current, 0);
            const newTime = this.moment(this.crop.date_planted).add(total, 'weeks').unix();
            if(newTime > currentTime) {
                return true;
            }
            return false;
        }
    },
    methods: {
        
    }
}
</script>

<style>

</style>
